import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0 2rem 0;

  & > span {
    color: ${({ theme }) => theme.colors.grayDark};
    font-weight: 600;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }

  & .ant-row > .ant-radio-wrapper {
    color: ${({ theme }) => theme.colors.graySubTitle};
    font-size: 0.875rem;
  }
`;
